import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import { getObject } from "../../services/metService";

import styles from "./ArtworkDetails.module.css";

export default function ArtworkDetails() {
  const { id } = useParams();
  const [artwork, setArtwork] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    async function loadArtwork() {
      const data = await getObject(id);
      if (!mounted) return;
      setArtwork(data);
      setLoading(false);
    }
    loadArtwork();
    return () => {
      mounted = false;
    };
  }, [id]);

  if (loading) {
    return <p style={{ padding: "30px" }}>Carregando obra...</p>;
  }

  if (!artwork) {
    return <p style={{ padding: "30px" }}>Obra não encontrada.</p>;
  }

  const {
    title,
    primaryImage,
    artistDisplayName,
    artistDisplayBio,
    culture,
    period,
    objectDate,
    medium,
    dimensions,
    department,
    repository,
    objectURL,
  } = artwork;

  return (
    <>
      {/* Breadcrumbs fica logo abaixo do Header (Header é global em AppRoutes) */}
      <div className={styles.breadcrumbsWrap}>
        <Breadcrumbs title={title} />
      </div>

      <div className={styles.container}>
        {/* Imagem grande */}
        <div className={styles.imageWrapper}>
          {primaryImage ? (
            <img src={primaryImage} alt={title} className={styles.image} />
          ) : (
            <div className={styles.placeholder}>Sem imagem</div>
          )}
        </div>

        {/* Informações */}
        <div className={styles.info}>
          <h1 className={styles.title}>{title}</h1>

          {artistDisplayName && (
            <p className={styles.artist}>
              <strong>Artista:</strong> {artistDisplayName}
            </p>
          )}

          {objectDate && (
            <p className={styles.field}>
              <strong>Ano:</strong> {objectDate}
            </p>
          )}

          {period && (
            <p className={styles.field}>
              <strong>Período:</strong> {period}
            </p>
          )}

          {culture && (
            <p className={styles.field}>
              <strong>Cultura:</strong> {culture}
            </p>
          )}

          {medium && (
            <p className={styles.field}>
              <strong>Técnica / Material:</strong> {medium}
            </p>
          )}

          {dimensions && (
            <p className={styles.field}>
              <strong>Dimensões:</strong> {dimensions}
            </p>
          )}

          {department && (
            <p className={styles.field}>
              <strong>Departamento:</strong> {department}
            </p>
          )}

          {repository && (
            <p className={styles.field}>
              <strong>Localização atual:</strong> {repository}
            </p>
          )}

          {artistDisplayBio && (
            <p className={styles.field}>
              <strong>Biografia:</strong> {artistDisplayBio}
            </p>
          )}

          {objectURL && (
            <a
              href={objectURL}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              Página oficial no The Met →
            </a>
          )}
        </div>
      </div>
    </>
  );
}
